export default "__VITE_ASSET__KWVHNcAU__"